import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.string.isRequired,
  firstName: PropTypes.string,
  surname: PropTypes.string,
});
